export const ApiDef_AdvisorWizard = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map